import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import AddSellTask from "./addSellTask.js";
import AddDoTaskMailContent from "./addDoTaskMailContent.js";
import AddDoTaskPhoneContent from "./addDoTaskPhoneContent.js";
import withReactContent from "sweetalert2-react-content";
import "../styles/task_popup.css";
import NotePopUp from "./note_popup.js";
import { secretKey } from "../.././data";
import Loading from "../helpers/loading_component.js";
import AddSellTaskDoTask from "./addSellTaskDoTask.js";
import LeadPopUp from "./lead_popup.js";
import SendSellClientMail from "./sendSellClientMail.js";
import SendSellClientSMS from "./sendSellClientSMS.js";
import AnSKD from "./anSKD.js";

const MySwal = withReactContent(Swal2);

const SellTaskPopUp = (props) => {
  const [taskData, setTaskData] = useState([]);
  const [status, setStatus] = useState([]);
  const [openEdit, setOpenEdit] = useState(false);
  const [notePopUp, setNotePopUp] = useState(false);
  const [loading, setLoading] = useState(true);
  const [showAddMailPopUp, setShowAddMailPopUp] = useState(false);
  const [showAddPhonePopUp, setShowAddPhonePopUp] = useState(false);
  const [showNewTaskPopUp, setShowNewTaskPopUp] = useState(false);
  const [showSendMailPopUp, setShowSendMailPopUp] = useState(false);
  const [showSendSMSPopUp, setShowSendSMSPopUp] = useState(false);
  const [leadC, setLeadC] = useState("");
  const [showLeadPopUp, setShowLeadPopUp] = useState(false);
  const [showSkdAn, setShowSkdAn] = useState(false);
  const [ass, setAss] = useState(false);
  const [ass4, setAss4] = useState(false);
  const [switchF, setSwitchF] = useState(false);

  const fetchTasksData = async () => {
    var body = {
      id: props.taskId,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getSellTaskId", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then(async (data) => {
        setTaskData(data[0]);
        fetchLeadData(data[0].leadId);
      })
      .catch((error) => {});
  };

  const fetchLeadData = async (leadId) => {
    var body = {
      id: leadId,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getLeadId", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then(async (data) => {
        setLeadC(data[0]);
        if (data[0].type === "SKD" && data[0].skd_ank !== "1") {
          MySwal.fire({
            icon: "success",
            title: "Pamiętaj",
            text: "o uzupełnieniu ankiety SKD w rozmowie z klientem",
          });
        }
        fetchSellStatus();
      })
      .catch((error) => {
        props.close();
      });
  };

  const fetchSellStatus = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getSellStatus", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then(async (data) => {
        setStatus(data);
        fetchSwitch();
      })
      .catch((error) => {});
  };

  const fetchSwitch = async () => {
    var body = {};

    await fetch("https://apidevkppp.ftpeople.pl/getLeadLoopChfSwitch", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setSwitchF(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  const getData = () => {
    setLoading(true);
    fetchTasksData();
  };

  useEffect(() => {
    getData();
  }, []);

  const setStatusX = () => {
    if (
      taskData.task ===
        "Skontaktuj się telefonicznie z klientem – pierwszy kontakt - poranny" ||
      taskData.task ===
        "Skontaktuj się telefonicznie z klientem – drugi kontakt - popołudniowy" ||
      taskData.task ===
        "Skontaktuj się telefonicznie z klientem – trzeci kontakt" ||
      taskData.task ===
        "Skontaktuj się telefonicznie z klientem – pierwszy kontakt" ||
      taskData.task ===
        "Skontaktuj się telefonicznie z klientem – pierwszy kontakt - SKD" ||
      taskData.task ===
        "Skontaktuj się telefonicznie z klientem – po zamknięciu" ||
      taskData.task ===
        "Skontaktuj się telefonicznie z klientem – po zamknięciu - SKD" ||
      leadC.status === "Ponowna próba uzyskania umowy" ||
      leadC.status === "ponowna próba uzyskania umowy" ||
      props.user.role === "consultantTele" ||
      props.uData.role === "consultantTele"
    ) {
      console.log("asdas");
      saveAcceptTask();
      return;
    } else if (
      taskData.task === "Ostatni kontakt" ||
      taskData.task === "Ostatni kontakt - SKD"
    ) {
      saveAcceptTaskLast();
      return;
    } else {
      var model = [];

      status.map((el) => {
        if (el.status !== "oznaczono do zamknięcia") {
          model[el.status] = el.status;
        }
      });
      if (
        taskData.task === "Negatywna rekomendacja SKD - kontakt z klientem" ||
        taskData.task ===
          "Negatywna rekomendacja SKD - kontakt z klientem - SKD"
      ) {
        saveAcceptTask();
      } else {
        MySwal.fire({
          title: "Proszę o wskazanie bieżącego statusu zgłoszenia",
          input: "select",
          inputOptions: model,
          inputPlaceholder: "wybierz status",
          showCancelButton: true,
          cancelButtonText: "Anuluj",
          inputValidator: function (value) {
            return new Promise(function (resolve, reject) {
              if (value !== "") {
                resolve();
              } else {
                resolve("musisz wybrać status");
              }
            });
          },
        }).then(async function (result) {
          if (result.isConfirmed) {
            var res = result.value;

            var body = {
              leadId: taskData.leadId,
              value: res,
              reason: "",
            };

            fetch("https://apidevkppp.ftpeople.pl/updateLeadStatus", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: secretKey,
              },
              body: JSON.stringify(body),
            })
              .then((response) => response.text())
              .then((data) => {
                saveAcceptTask();
              })
              .catch((error) => {});
          } else {
            saveAcceptTask();
          }
        });
      }
    }
  };

  const saveAcceptTaskLast = async () => {
    setLoading(true);

    var body = {
      id: props.taskId,
      user: props.user.name,
    };

    await fetch("https://apidevkppp.ftpeople.pl/doSellTask2", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then(async (data) => {
        MySwal.fire({
          title: "Czy chcesz zamknąć kontakt?",
          showDenyButton: true,
          showCancelButton: false,
          confirmButtonText: "Tak",
          denyButtonText: `Nie`,
        }).then(async (result) => {
          if (result.isConfirmed) {
            var body = {
              id: leadC.id,
            };

            await fetch(
              "https://apidevkppp.ftpeople.pl/closeAndArchivizeLead",
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: secretKey,
                },
                body: JSON.stringify(body),
              }
            )
              .then((response) => response.text())
              .then(async (data) => {
                MySwal.fire({
                  icon: "success",
                  title: "Wykonano",
                  text: "zadanie sprzedażowe",
                }).then(() => {
                  getData();
                });
              });
          } else if (result.isDenied) {
            MySwal.fire({
              icon: "success",
              title: "Wykonano",
              text: "zadanie sprzedażowe",
            }).then(() => {
              getData();
            });
          }
        });
      })
      .catch((error) => {});
  };

  const saveAcceptTask = async () => {
    setLoading(false);

    var body = {
      id: props.taskId,
      leadId: taskData.leadId,
      task: taskData.task,
      user: props.user.name,
    };

    await fetch("https://apidevkppp.ftpeople.pl/doSellTask2", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then(async (data) => {
        if (
          taskData.task === "Negatywna rekomendacja SKD - kontakt z klientem" ||
          taskData.task ===
            "Negatywna rekomendacja SKD - kontakt z klientem - SKD"
        ) {
          setShowSendMailPopUp(true);
        } else if (
          taskData.task !== "Skontaktuj się mailowo z klientem" ||
          (taskData.task !== "Skontaktuj się mailowo z klientem - SKD" &&
            !(
              taskData.task === "Skontaktuj się telefonicznie z klientem" ||
              taskData.task ===
                "Skontaktuj się telefonicznie z klientem - SKD" ||
              taskData.task ===
                "Skontaktuj się telefonicznie z klientem – pierwszy kontakt" ||
              taskData.task ===
                "Skontaktuj się telefonicznie z klientem – pierwszy kontakt - poranny" ||
              taskData.task ===
                "Skontaktuj się telefonicznie z klientem – drugi kontakt - popołudniowy" ||
              taskData.task ===
                "Skontaktuj się telefonicznie z klientem – trzeci kontakt" ||
              taskData.task ===
                "Skontaktuj się telefonicznie z klientem – pierwszy kontakt - SKD" ||
              taskData.task ===
                "Skontaktuj się telefonicznie z klientem – po zamknięciu" ||
              taskData.task ===
                "Skontaktuj się telefonicznie z klientem – po zamknięciu - SKD" ||
              leadC.status === "Ponowna próba uzyskania umowy" ||
              leadC.status === "ponowna próba uzyskania umowy"
            ))
        ) {
          MySwal.fire({
            icon: "success",
            title: "Wykonano",
            text: "zadanie sprzedażowe",
          }).then(() => {
            getData();
          });
        }
      })
      .catch((error) => {});

    if (
      taskData.task === "Skontaktuj się mailowo z klientem" ||
      taskData.task === "Skontaktuj się mailowo z klientem - SKD"
    ) {
      addTaskIfCond1();
    }

    if (
      taskData.task === "Skontaktuj się telefonicznie z klientem" ||
      taskData.task === "Skontaktuj się telefonicznie z klientem - SKD" ||
      taskData.task ===
        "Skontaktuj się telefonicznie z klientem – po zamknięciu" ||
      taskData.task ===
        "Skontaktuj się telefonicznie z klientem – po zamknięciu - SKD" ||
      leadC.status === "Ponowna próba uzyskania umowy" ||
      leadC.status === "ponowna próba uzyskania umowy"
    ) {
      addTaskIfCond2();
    }

    if (
      taskData.task ===
        "Skontaktuj się telefonicznie z klientem – pierwszy kontakt" ||
      taskData.task ===
        "Skontaktuj się telefonicznie z klientem – pierwszy kontakt - poranny" ||
      taskData.task ===
        "Skontaktuj się telefonicznie z klientem – drugi kontakt - popołudniowy" ||
      taskData.task ===
        "Skontaktuj się telefonicznie z klientem – pierwszy kontakt - SKD"
    ) {
      addTaskIfCond3();
    }
  };

  const closeLeadPopUp = () => {
    setShowLeadPopUp(false);
  };

  const addTaskIfCond1 = () => {
    setShowAddMailPopUp(true);
  };

  const rekLead = async () => {
    var body = {
      id: leadC.id,
      reason: "nieprawidłowy numer telefonu",
    };

    await fetch("https://apidevkppp.ftpeople.pl/rekLead", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});
  };

  const assLead = async () => {
    var body = {
      leadId: leadC.id,
    };

    await fetch("https://apidevkppp.ftpeople.pl/splitLeadCHF", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});
  };

  const addTaskIfCond2 = () => {
    var ass3 = false;
    MySwal.fire({
      title: "Czy kontakt telefoniczny był skuteczny?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then((result2) => {
      if (result2.isConfirmed) {
        setAss4(true);
        setShowAddPhonePopUp(true);
      } else if (result2.isDenied) {
        setAss4(false);
        setShowAddPhonePopUp(true);
      }
    });
  };

  const addTaskIfCond3 = () => {
    var ass3 = false;
    MySwal.fire({
      title: "Czy kontakt telefoniczny był skuteczny?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then((result2) => {
      if (result2.isConfirmed) {
        MySwal.fire({
          title: "Czy klient zadeklarował przesłanie umowy?",
          showDenyButton: true,
          showCancelButton: false,
          confirmButtonText: "Tak",
          denyButtonText: `Nie`,
        }).then((result3) => {
          if (result3.isConfirmed) {
            if (switchF) {
              assLead();
              setAss(true);
            }

            var body2 = {
              id: taskData.leadId,
            };

            fetch("https://apidevkppp.ftpeople.pl/getLeadId", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                Authorization: secretKey,
              },
              body: JSON.stringify(body2),
            })
              .then((response) => response.json())
              .then((data) => {
                var body2 = {
                  leadId: taskData.leadId,
                  leadName: data[0].name,
                  field: "decAgg",
                  value: "TAK",
                };

                fetch("https://apidevkppp.ftpeople.pl/updateLead", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: secretKey,
                  },
                  body: JSON.stringify(body2),
                })
                  .then((response) => response.json())
                  .then((data) => {})
                  .catch((error) => {});

                var body = {
                  type: "Telefoniczny - skuteczny",
                  content: "Klient zadeklarował przesłanie umowy",
                  date: new Date(),
                  leadId: taskData.leadId,
                  user: props.user.name,
                };

                fetch("https://apidevkppp.ftpeople.pl/addSellClientContact", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: secretKey,
                  },
                  body: JSON.stringify(body),
                })
                  .then((response) => response.json())
                  .then((data) => {})
                  .catch((error) => {});
                setAss4(true);
                setShowAddPhonePopUp(true);
              })
              .catch((error) => {});
          } else if (result3.isDenied) {
            setAss4(true);
            setShowAddPhonePopUp(true);
          }
        });
      } else if (result2.isDenied) {
        if (
          props.user.role === "consultantTele" ||
          props.uData.role === "consultantTele"
        ) {
          MySwal.fire({
            title: "Czy numer telefonu był prawidłowy?",
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: "Tak",
            denyButtonText: `Nie`,
          }).then((result) => {
            if (result.isConfirmed) {
              setAss4(false);
              setShowAddPhonePopUp(true);
            } else {
              rekLead();
              setAss(true);
              setAss4(false);
              setShowAddPhonePopUp(true);
            }
          });
        } else {
          MySwal.fire({
            title: "Czy numer telefonu był prawidłowy?",
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: "Tak",
            denyButtonText: `Nie`,
          }).then((result) => {
            if (result.isConfirmed) {
              setAss4(false);
              setShowAddPhonePopUp(true);
            } else {
              rekLead();
              setAss(true);
              setAss4(false);
              setShowAddPhonePopUp(true);
            }
          });
        }
      }
    });
  };

  const deleteTask = async () => {
    setLoading(true);
    var body = {
      id: props.taskId,
      user: props.user ? props.user.name : props.uData.name,
    };

    await fetch("https://apidevkppp.ftpeople.pl/deleteSellTask", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.text())
      .then(async (data) => {
        MySwal.fire({
          icon: "success",
          title: "Usunięto",
          text: "zadanie sprzedażowe",
        }).then((result) => {
          props.close();
        });
      })
      .catch((error) => {});
  };

  const showEditMode = () => {
    setOpenEdit(true);
  };

  const closeEditMode = () => {
    setOpenEdit(false);
    getData();
  };

  const showNotePopUp = () => {
    if (notePopUp) {
      setNotePopUp(false);
      getData();
    } else {
      setNotePopUp(true);
    }
  };

  const closeSendMail = () => {
    setShowSendMailPopUp(false);
    if (
      taskData.task === "Negatywna rekomendacja SKD - kontakt z klientem" ||
      taskData.task === "Negatywna rekomendacja SKD - kontakt z klientem - SKD"
    ) {
      sendSMSChoose3();
    } else if (
      leadC.status === "Ponowna próba uzyskania umowy" ||
      leadC.status === "ponowna próba uzyskania umowy"
    ) {
      sendSMSChoose();
    } else {
      sendSMSChoose2();
    }
  };

  const closeSendSMS = () => {
    setShowSendSMSPopUp(false);
    if (
      leadC.status === "Ponowna próba uzyskania umowy" ||
      leadC.status === "ponowna próba uzyskania umowy"
    ) {
      checkCounter();
    } else {
      MySwal.fire({
        icon: "success",
        title: "Wykonano",
        text: "zadanie sprzedażowe",
      }).then(() => {
        getData();
      });
    }
  };

  const closeAddMailContent = () => {
    setShowAddMailPopUp(false);
    if (
      leadC.status === "Ponowna próba uzyskania umowy" ||
      leadC.status === "ponowna próba uzyskania umowy"
    ) {
      sendSMSChoose();
    } else {
      sendSMSChoose2();
    }
  };

  const closeAddMailContentPlus = () => {
    setShowNewTaskPopUp(true);
    setShowAddMailPopUp(false);
  };

  const closeAddPhoneContent = () => {
    setShowAddPhonePopUp(false);

    MySwal.fire({
      title: "Czy chcesz wysłać e-mail?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then((result) => {
      if (result.isConfirmed) {
        addClientContactMail("yes");
        setShowSendMailPopUp(true);
      } else if (result.isDenied) {
        addClientContactMail("no");
        if (
          leadC.status === "Ponowna próba uzyskania umowy" ||
          leadC.status === "ponowna próba uzyskania umowy"
        ) {
          sendSMSChoose();
        } else {
          sendSMSChoose2();
        }
      }
    });
  };

  const closeAddPhoneContentPlus = () => {
    setShowNewTaskPopUp(true);
    setShowAddPhonePopUp(false);
  };

  const closeAddTask = () => {
    setShowNewTaskPopUp(false);

    MySwal.fire({
      title: "Czy chcesz wysłać e-mail?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then((result) => {
      if (result.isConfirmed) {
        addClientContactMail("yes");
        setShowSendMailPopUp(true);
      } else if (result.isDenied) {
        addClientContactMail("no");
        if (
          leadC.status === "Ponowna próba uzyskania umowy" ||
          leadC.status === "ponowna próba uzyskania umowy"
        ) {
          sendSMSChoose();
        } else {
          sendSMSChoose2();
        }
      }
    });
  };

  const sendSMSChoose = () => {
    MySwal.fire({
      title: "Czy chcesz wysłać wiadomość SMS?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        addClientContactSMS("yes");
        setShowSendSMSPopUp(true);
      } else if (result.isDenied) {
        addClientContactSMS("no");
        checkCounter();
      }
    });
  };

  const sendSMSChoose2 = () => {
    MySwal.fire({
      title: "Czy chcesz wysłać wiadomość SMS?",
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: "Tak",
      denyButtonText: `Nie`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        addClientContactSMS("yes");
        setShowSendSMSPopUp(true);
      } else if (result.isDenied) {
        addClientContactSMS("no");
        MySwal.fire({
          icon: "success",
          title: "Wykonano",
          text: "zadanie sprzedażowe",
        }).then(() => {
          getData();
        });
      }
    });
  };

  const sendSMSChoose3 = () => {
    MySwal.fire({
      icon: "success",
      title: "Wykonano",
      text: "zadanie sprzedażowe",
    }).then(() => {
      getData();
    });
  };

  const handleShowSkdAn = (e) => {
    setShowSkdAn(true);
  };

  const closeAddSkdAn = (e) => {
    setShowSkdAn(false);
    getData();
  };

  const checkCounter = async () => {
    if (
      leadC.status === "ponowna próba uzyskania umowy" ||
      leadC.status === "Ponowna próba uzyskania umowy" ||
      taskData.task.replaceAll(" - SKD", "") === "Ostatni kontakt"
    ) {
      MySwal.fire({
        title: "Czy chcesz zamknąć kontakt?",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "Tak",
        denyButtonText: `Nie`,
      }).then(async (result) => {
        if (result.isConfirmed) {
          var body = {
            id: leadC.id,
          };

          await fetch("https://apidevkppp.ftpeople.pl/closeAndArchivizeLead", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: secretKey,
            },
            body: JSON.stringify(body),
          })
            .then((response) => response.text())
            .then(async (data) => {
              MySwal.fire({
                icon: "success",
                title: "Wykonano",
                text: "zadanie sprzedażowe",
              }).then(() => {
                getData();
              });
            });
        } else if (result.isDenied) {
          var body = {
            leadId: leadC.id,
            user: props.user.name,
          };

          await fetch("https://apidevkppp.ftpeople.pl/getTaskCancel", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: secretKey,
            },
            body: JSON.stringify(body),
          })
            .then((response) => response.json())
            .then(async (data) => {
              var counter = data[0].count;

              if (+counter >= 4) {
                MySwal.fire({
                  title:
                    "Wykonałeś już 4 kontakty – czy kolejne zadanie powinno być dodane jako ostatni kontakt?",
                  showDenyButton: true,
                  showCancelButton: false,
                  confirmButtonText: "Tak",
                  denyButtonText: `Nie`,
                }).then(async (result) => {
                  if (result.isConfirmed) {
                    var dateTask = new Date(
                      new Date().setDate(new Date().getDate() + 5)
                    );
                    if (dateTask.getDay() === 0) {
                      dateTask = new Date(
                        dateTask.setDate(dateTask.getDate() + 1)
                      );
                    }
                    if (dateTask.getDay() === 6) {
                      dateTask = new Date(
                        dateTask.setDate(dateTask.getDate() + 2)
                      );
                    }

                    var date =
                      new Date(dateTask).getFullYear() +
                      "-" +
                      (new Date(dateTask).getMonth() + 1 < 10
                        ? "0" + (new Date(dateTask).getMonth() + 1)
                        : new Date(dateTask).getMonth() + 1) +
                      "-" +
                      (new Date(dateTask).getDate() < 10
                        ? "0" + new Date(dateTask).getDate()
                        : new Date(dateTask).getDate());

                    var body = {
                      startDate: date,
                      finalDate: date,
                      leadName: leadC.name,
                      task:
                        leadC.type === "SKD"
                          ? "Ostatni kontakt - SKD"
                          : "Ostatni kontakt",
                      responsible: props.user.name,
                      noteTask: "",
                      status: "ZLECONE",
                      leadId: leadC.id,
                      addUser: props.user.name,
                    };

                    await fetch("https://apidevkppp.ftpeople.pl/addSellTask", {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                        Authorization: secretKey,
                      },
                      body: JSON.stringify(body),
                    })
                      .then((response) => response.text())
                      .then(async (data) => {
                        MySwal.fire({
                          icon: "success",
                          title: "Wykonano",
                          text: "zadanie sprzedażowe",
                        }).then((result) => {
                          getData();
                        });
                      })
                      .catch((error) => {});
                  } else if (result.isDenied) {
                    MySwal.fire({
                      icon: "success",
                      title: "Wykonano",
                      text: "zadanie sprzedażowe",
                    }).then(() => {
                      getData();
                    });
                  }
                });
              } else {
                MySwal.fire({
                  icon: "success",
                  title: "Wykonano",
                  text: "zadanie sprzedażowe",
                }).then((result) => {
                  getData();
                });
              }
            })
            .catch((error) => {});
        }
      });
    } else {
      var body = {
        leadId: leadC.id,
        user: props.user.name,
      };

      await fetch("https://apidevkppp.ftpeople.pl/getTaskCancel", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: secretKey,
        },
        body: JSON.stringify(body),
      })
        .then((response) => response.json())
        .then(async (data) => {
          var counter = data[0].count;

          if (+counter >= 4) {
            MySwal.fire({
              title:
                "Wykonałeś już 4 kontakty – czy kolejne zadanie powinno być dodane jako ostatni kontakt?",
              showDenyButton: true,
              showCancelButton: false,
              confirmButtonText: "Tak",
              denyButtonText: `Nie`,
            }).then(async (result) => {
              if (result.isConfirmed) {
                var dateTask = new Date(
                  new Date().setDate(new Date().getDate() + 5)
                );
                if (dateTask.getDay() === 0) {
                  dateTask = new Date(dateTask.setDate(dateTask.getDate() + 1));
                }
                if (dateTask.getDay() === 6) {
                  dateTask = new Date(dateTask.setDate(dateTask.getDate() + 2));
                }

                var date =
                  new Date(dateTask).getFullYear() +
                  "-" +
                  (new Date(dateTask).getMonth() + 1 < 10
                    ? "0" + (new Date(dateTask).getMonth() + 1)
                    : new Date(dateTask).getMonth() + 1) +
                  "-" +
                  (new Date(dateTask).getDate() < 10
                    ? "0" + new Date(dateTask).getDate()
                    : new Date(dateTask).getDate());

                var body = {
                  startDate: date,
                  finalDate: date,
                  leadName: leadC.name,
                  task:
                    leadC.type === "SKD"
                      ? "Ostatni kontakt - SKD"
                      : "Ostatni kontakt",
                  responsible: props.user.name,
                  noteTask: "",
                  status: "ZLECONE",
                  leadId: leadC.id,
                  addUser: props.user.name,
                };

                await fetch("https://apidevkppp.ftpeople.pl/addSellTask", {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: secretKey,
                  },
                  body: JSON.stringify(body),
                })
                  .then((response) => response.text())
                  .then(async (data) => {
                    MySwal.fire({
                      icon: "success",
                      title: "Wykonano",
                      text: "zadanie sprzedażowe",
                    }).then((result) => {
                      getData();
                    });
                  })
                  .catch((error) => {});
              } else if (result.isDenied) {
                MySwal.fire({
                  icon: "success",
                  title: "Wykonano",
                  text: "zadanie sprzedażowe",
                }).then(() => {
                  getData();
                });
              }
            });
          } else {
            MySwal.fire({
              icon: "success",
              title: "Wykonano",
              text: "zadanie sprzedażowe",
            }).then((result) => {
              getData();
            });
          }
        })
        .catch((error) => {});
    }
  };

  const addClientContactSMS = async (choose) => {
    var body = {
      type: "SMS",
      content:
        choose === "yes"
          ? "Wysłano wiadomość SMS do klienta"
          : "Nie wysłano wiadomości SMS do klienta",
      date: new Date(),
      leadId: leadC.id,
      user: props.uData.name,
    };

    await fetch("https://apidevkppp.ftpeople.pl/addSellClientContact", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});
  };

  const addClientContactMail = async (choose) => {
    var body = {
      type: "Mailowy",
      content:
        choose === "yes"
          ? "Wysłano wiadomość e-mail do klienta"
          : "Nie wysłano wiadomości e-mail do klienta",
      date: new Date(),
      leadId: leadC.id,
      user: props.uData.name,
    };

    await fetch("https://apidevkppp.ftpeople.pl/addSellClientContact", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {})
      .catch((error) => {});
  };

  return (
    <>
      <>
        <div className="mainContainerTaskPopUp">
          {loading ? (
            <Loading id="popUpLoading" />
          ) : showLeadPopUp ? (
            <>
              <LeadPopUp
                close={closeLeadPopUp}
                lead={leadC}
                logLeadAction={props.logLeadAction}
                user={props.user}
                uData={props.uData}
              />
            </>
          ) : (
            <>
              <div className="closeBox">
                <button className="closeClientButton" onClick={props.close}>
                  X
                </button>
              </div>
              <div className="hearingTitle">
                Zadanie: <span className="highlight">{taskData.task}</span>
              </div>
              <div className="editButtonBox">
                {true ? (
                  <>
                    {taskData.status === "ZLECONE" ? (
                      <>
                        <button className="acceptButton" onClick={showEditMode}>
                          EDYTUJ
                        </button>
                      </>
                    ) : (
                      ""
                    )}
                    {taskData.status === "ZLECONE" &&
                    props.user.role !== "consultantTele" ? (
                      <>
                        <button className="acceptButton" onClick={deleteTask}>
                          Usuń
                        </button>
                      </>
                    ) : (
                      ""
                    )}
                  </>
                ) : (
                  ""
                )}
              </div>
              <div style={{ display: "block" }} className="editButtonBox">
                <div style={{ marginBottom: "15px" }}>
                  <span style={{ color: "black" }} className="highlight_green">
                    KONTAKT: {leadC !== undefined ? leadC.name : ""}
                  </span>
                </div>
                <div style={{ display: "flex", gap: "20px" }}>
                  <button
                    style={{ fontSize: "0.7vw" }}
                    className="acceptButton"
                    onClick={(e) => {
                      setShowLeadPopUp(true);
                    }}
                  >
                    ZOBACZ
                  </button>
                </div>
              </div>
              <div className="hearingData">
                <div className="hearingBox">
                  <div className="hearingBoxTitle">DATA ROZPOCZĘCIA</div>
                  <div className="hearingBoxContent">{taskData.startDate}</div>
                </div>
                <div className="hearingBox">
                  <div className="hearingBoxTitle">TERMIN WYKONANIA</div>
                  <div className="hearingBoxContent">{taskData.finalDate}</div>
                </div>
                <div className="hearingBox">
                  <div className="hearingBoxTitle">IMIĘ I NAZWISKO KLIENTA</div>
                  <div className="hearingBoxContent">{taskData.leadName}</div>
                </div>
                <div className="hearingBox">
                  <div className="hearingBoxTitle">OSOBA ODPOWIEDZIALNA</div>
                  <div className="hearingBoxContent">
                    {taskData.responsible}
                  </div>
                </div>
                <div className="hearingBox">
                  <div className="hearingBoxTitle">STATUS</div>
                  <div className="hearingBoxContent">{taskData.status}</div>
                </div>
                <div className="hearingBox">
                  <div className="hearingBoxTitle">NOTATKA</div>
                  <div className="hearingBoxContent">
                    <div className="noteShort">
                      {taskData.noteTask === "undefined"
                        ? ""
                        : taskData.noteTask.substring(0, 100)}
                      ...
                    </div>
                    <button
                      id="boxButton"
                      className="acceptButton"
                      value="note"
                      onClick={showNotePopUp}
                    >
                      POKAŻ CAŁĄ TREŚĆ
                    </button>
                  </div>
                </div>
                {props.user.role === "consultantTele" ||
                props.uData.role === "consultantTele" ? (
                  <>
                    <div className="hearingBox">
                      <div className="hearingBoxTitle">NUMER TELEFONU</div>
                      <div className="hearingBoxContent">{leadC.phone}</div>
                    </div>
                  </>
                ) : (
                  ""
                )}
                {props.user.role === "consultantTele" ||
                props.uData.role === "consultantTele" ? (
                  <>
                    <div className="hearingBox">
                      <div className="hearingBoxTitle">RODZAJ SPRAWY</div>
                      <div className="hearingBoxContent">{leadC.type}</div>
                    </div>
                  </>
                ) : (
                  ""
                )}
              </div>
              <div className="hearingFunctionalitesBox">
                {
                  <>
                    {taskData.status === "ZLECONE" ? (
                      <>
                        <button
                          className="functionalitesButton"
                          value="fillHearing"
                          onClick={setStatusX}
                        >
                          OZNACZ JAKO WYKONANE
                        </button>
                      </>
                    ) : (
                      ""
                    )}
                    {leadC.type === "SKD" && taskData.status === "ZLECONE" ? (
                      <>
                        <button
                          className="functionalitesButton"
                          value="fillHearing"
                          onClick={handleShowSkdAn}
                        >
                          ANKIETA LEADA SKD
                        </button>
                      </>
                    ) : (
                      ""
                    )}
                  </>
                }
              </div>
              <div style={{ padding: "20px", zIndex: "0 " }}>
                {taskData.realDoDate
                  ? " Rzeczywista data wykonania zadania: " +
                    taskData.realDoDate
                  : ""}
              </div>
            </>
          )}
          {notePopUp ? (
            <NotePopUp
              content={taskData.noteTask}
              type={"note"}
              closePopUp={showNotePopUp}
            />
          ) : (
            ""
          )}
          {openEdit ? (
            <AddSellTask
              mode={"edit"}
              leadData={leadC}
              taskData={taskData}
              close={closeEditMode}
              user={props.user}
              uData={props.uData}
            />
          ) : (
            ""
          )}
          {showSendMailPopUp ? (
            <SendSellClientMail
              mode={"sellTask"}
              leadData={leadC}
              close={closeSendMail}
              userMail={props.user.mail ? props.user.mail : props.uData.mail}
              userPhone={
                props.user.phone ? props.user.phone : props.uData.phone
              }
              userName={props.user.name ? props.user.name : props.uData.name}
              logClientAction={props.logLeadAction}
              uData={props.uData ? props.uData : props.user}
            />
          ) : (
            ""
          )}
          {showSendSMSPopUp ? (
            <SendSellClientSMS
              mode={"sellTask"}
              leadData={leadC}
              close={closeSendSMS}
              userMail={props.user.mail ? props.user.mail : props.uData.mail}
              userPhone={
                props.user.phone ? props.user.phone : props.uData.phone
              }
              userName={props.user.name ? props.user.name : props.uData.name}
              logClientAction={props.logLeadAction}
              uData={props.uData ? props.uData : props.user}
            />
          ) : (
            ""
          )}
          {showAddMailPopUp ? (
            <AddDoTaskMailContent
              taskData={taskData}
              leadStatus={leadC.status}
              lead={taskData.leadId}
              user={props.user}
              logLeadAction={props.logLeadAction}
              close={closeAddMailContent}
              closePlus={closeAddMailContentPlus}
            />
          ) : (
            ""
          )}
          {showAddPhonePopUp ? (
            <AddDoTaskPhoneContent
              ass={ass}
              ass4={ass4}
              taskData={taskData}
              lead={taskData.leadId}
              user={props.user}
              logLeadAction={props.logLeadAction}
              close={closeAddPhoneContent}
              closePlus={closeAddPhoneContentPlus}
            />
          ) : (
            ""
          )}
          {showNewTaskPopUp ? (
            <AddSellTaskDoTask
              taskData={taskData}
              lead={taskData.leadId}
              leadData={leadC}
              user={props.user}
              logLeadAction={props.logLeadAction}
              close={closeAddTask}
              uData={props.uData}
            />
          ) : (
            ""
          )}
          {showSkdAn ? (
            <>
              <AnSKD
                leadData={leadC}
                close={closeAddSkdAn}
                user={props.uData.name}
                logClientAction={props.logLeadAction}
              />
            </>
          ) : (
            ""
          )}
        </div>
      </>
    </>
  );
};

export default SellTaskPopUp;
